import { useWSInfiniteQuery, WSInfiniteQueryConfig } from "@ws-react-query";
import {
  listRequirements,
  RequirementListResponse,
  RequirementsListQuery
} from "../../../services/requirements/listRequirements";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_REQUIREMENTS_LIST } from "../keys";

const PAGE_SIZE = 20;

export const useInfiniteQueryRequirementsList = (
  params?: RequirementsListQuery,
  config?: WSInfiniteQueryConfig<RequirementListResponse, WSServiceError>
) =>
  useWSInfiniteQuery<RequirementListResponse, WSServiceError>(
    [QUERY_REQUIREMENTS_LIST, params],
    async ({ pageParam = 1 }) =>
      await listRequirements({
        page: {
          size: PAGE_SIZE,
          number: pageParam
        },
        sort: {
          updatedAt: "desc"
        },
        ...params
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.data.length < PAGE_SIZE) {
          return undefined;
        } else {
          return allPages.length + 1;
        }
      },
      ...config
    }
  );
